import ImageLoader from "../../loader/ImageLoader";

// Preview for the single-image fields (profile / landing / welcome message).
// The image sizes itself and carries the border, so the frame hugs the photo
// instead of letterboxing it inside a fixed box.
const PhotoPreview = ({ label, photo, alt, emptyText }) => {
    return (
        <div className="h-[220px] border-b-[1.5px] bg-[#F2F7FF] p-3">
            <p className="text-[#737880] mb-2">{label}</p>

            {photo.loading ? (
                <div className="w-[260px] h-[160px] rounded-lg border-[1.5px] border-[#BFC4CC] overflow-hidden">
                    <ImageLoader width="100%" height="160px" />
                </div>
            ) : photo.error ? (
                <div className="w-[260px] h-[160px] rounded-lg border-[1.5px] border-red-300 bg-red-50 flex items-center justify-center text-sm text-red-500">
                    Failed to load image
                </div>
            ) : photo.url ? (
                <img
                    src={photo.url}
                    alt={alt}
                    className="max-h-[160px] max-w-full rounded-lg border-[1.5px] border-[#BFC4CC] bg-white"
                />
            ) : (
                <div className="w-[260px] h-[160px] rounded-lg border-[1.5px] border-dashed border-[#BFC4CC] flex items-center justify-center text-sm text-[#737880]">
                    {emptyText}
                </div>
            )}
        </div>
    );
};

export default PhotoPreview;
